import * as ActionType from "./serviceCategory.type";

const initialState = { serviceCategories: [] };

export const serviceCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.GET_SERVICE_CATEGORIES:
      return { ...state, serviceCategories: action.payload };
    case ActionType.CREATE_SERVICE_CATEGORY:
      return { ...state, serviceCategories: [...state.serviceCategories, action.payload] };
    case ActionType.UPDATE_SERVICE_CATEGORY:
      return {
        ...state,
        serviceCategories: state.serviceCategories.map((c) =>
          c._id === action.payload._id ? action.payload : c
        ),
      };
    case ActionType.DELETE_SERVICE_CATEGORY:
      return {
        ...state,
        serviceCategories: state.serviceCategories.filter((c) => c._id !== action.payload),
      };
    default:
      return state;
  }
};
